import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import _ from 'lodash';
import Flexbox from 'flexbox-react';
import ProcessUtils from 'utils/ProcessUtils';
import TransformationTypeParameter from 'components/core/fields/transformation_parameters/TransformationTypeParameter';
import BinAlignmentField from 'components/core/fields/BinAlignmentField';

/**
 * This component is ONLY used in WIZARD mode to render the basic dimension transformation type set on
 * the coordinate system (not set in transformation parameters)
 */
export default class TransformationsForm extends React.Component {
    static propTypes = {
        process: PropTypes.object,
        processErrors: PropTypes.object,
        hasWritePermissions: PropTypes.bool,
        exploredDatastreams: PropTypes.object,
        coordinateSystemName: PropTypes.string,
        dimensionName: PropTypes.string,
        dimensionIsTime: PropTypes.bool,
        siteFacilities: PropTypes.array,
        className: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            advancedSettingsValue: false,
            outputOverRide: false,
            disabled: false,
            transformationTypeValue: this.getTransforamtionTypeValue()
        };
        this.boldFont = css`font-weight:900;`;
    }

    getBaseDimensionPath = () => {
        return ['variable_retrieval', 'coordinate_systems', this.props.coordinateSystemName, 'dimensions', this.props.dimensionName];
    };

    getDimension = () => {
        return _.get(this.props.process, this.getBaseDimensionPath());
    };

    getTransforamtionTypeValue = () => {
        const dimension = this.getDimension();
        return dimension.data_transformation.transformation_type;
    };

    onFieldUpdated = (fieldPath, value) => {
        ProcessUtils.updateField(this.props.process, fieldPath, value.value);
    };

    render = () => {
        const className = this.props.className ? this.props.className : '';
        const marginBottomStyles = css`margin-bottom:15px`;

        return (
            <Flexbox flexDirection={'column'} className={className}>
                <Flexbox className={marginBottomStyles}>
                    <TransformationTypeParameter
                        process={this.props.process}
                        processErrors={this.props.processErrors}
                        coordinateSystemName={this.props.coordinateSystemName}
                        dimensionName={this.props.dimensionName}
                        hasWritePermissions={this.props.hasWritePermissions}
                        wizardMode
                    />
                </Flexbox>
                <BinAlignmentField
                    process={this.props.process}
                    processErrors={this.props.processErrors}
                    coordinateSystemName={this.props.coordinateSystemName}
                    dimensionName={this.props.dimensionName}
                    hasWritePermissions={this.props.hasWritePermissions}
                />
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/forms/TransformationsForm.js